import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { 
  Car, Wrench, Paintbrush, Sparkles, 
  Clock, Phone, MapPin, ChevronRight, Star, Award,
  Droplets, Users, CheckCircle, Calendar, MessageCircle,
  Play, ArrowRight, Quote, Shield, Truck, Euro, Wallet, Disc
} from 'lucide-react';
import { useState } from 'react';

// Images
const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/83a2641e-b7ab-41ca-ae72-cc388d3b119a/images/a8b143ed49fac5f985e0c285bf0327e484736d812424db130492f0ee616f15e6.png";
const DETAILING_IMG = "https://images.unsplash.com/photo-1654522660328-eede2194e699?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYXIlMjBkZXRhaWxpbmclMjBiZWZvcmUlMjBhZnRlcnxlbnwwfHx8fDE3NzU5MjY1MTV8MA&ixlib=rb-4.1.0&q=85";
const MECHANIC_IMG = "https://images.unsplash.com/photo-1770656505767-32ed52b1a8ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxjYXIlMjBtZWNoYW5pYyUyMHdvcmtpbmclMjBlbmdpbmV8ZW58MHx8fHwxNzc1OTI2NTIwfDA&ixlib=rb-4.1.0&q=85";
const CARROSSERIE_IMG = "https://images.unsplash.com/photo-1632605185825-fd583793fa73?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxjYXIlMjBib2R5JTIwcmVwYWlyJTIwcGFpbnQlMjBzaG9wfGVufDB8fHx8MTc3NTkyNjUyNXww&ixlib=rb-4.1.0&q=85";
const BEFORE_AFTER_1 = "https://images.unsplash.com/photo-1654522659474-ca5e43f52258?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjYXIlMjBkZXRhaWxpbmclMjBiZWZvcmUlMjBhZnRlcnxlbnwwfHx8fDE3NzU5MjY1MTV8MA&ixlib=rb-4.1.0&q=85";
const BEFORE_AFTER_2 = "https://images.unsplash.com/photo-1770700391793-22fc46041c2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjBkZXRhaWxpbmclMjBiZWZvcmUlMjBhZnRlcnxlbnwwfHx8fDE3NzU5MjY1MTV8MA&ixlib=rb-4.1.0&q=85";

// Avis clients
const reviews = [
  {
    name: "Jean-Pierre M.",
    rating: 5,
    text: "Service incroyable ! Ma voiture est comme neuve. L'équipe est très professionnelle et le résultat dépasse mes attentes. Je recommande vivement !",
    date: "Il y a 2 semaines"
  },
  {
    name: "Marie L.",
    rating: 5,
    text: "Excellent service de lavage et detailing. Mon véhicule n'a jamais été aussi propre. Personnel accueillant et travail soigné.",
    date: "Il y a 1 mois"
  },
  {
    name: "Thomas D.",
    rating: 5,
    text: "Réparation carrosserie parfaite, on ne voit plus aucune trace de l'accident. Prix très correct pour la qualité du travail fourni.",
    date: "Il y a 3 semaines"
  },
  {
    name: "Sophie R.",
    rating: 5,
    text: "Super garage ! J'ai fait réviser ma moto et le travail est impeccable. Ils prennent soin des véhicules comme si c'étaient les leurs.",
    date: "Il y a 1 semaine"
  }
];

export default function HomePage() {
  const [activeReview, setActiveReview] = useState(0);

  return (
    <div className="min-h-screen bg-[#09090B]">
      {/* WhatsApp Floating Button */}
      <a 
        href="https://wa.me/33805032032?text=Bonjour%20Le%20Hub%20Atelier%20-%20Centre%20Auto%20%26%20Moto%20Paris%2016%20!%20Je%20souhaite%20avoir%20des%20informations."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:scale-110 transition-all duration-300 flex items-center gap-2 group"
        data-testid="whatsapp-btn"
      >
        <MessageCircle size={28} fill="white" />
        <span className="hidden group-hover:inline text-sm font-medium pr-2">0805 032 032</span>
      </a>

      {/* 1. HERO SECTION */}
      <section className="relative min-h-[90vh] flex items-center overflow-hidden" data-testid="hero-section">
        <div className="absolute inset-0 w-full h-full">
          <img
            src={HERO_BG}
            alt="Le Hub Atelier Auto Moto"
            className="absolute w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/50" />
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-20">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 bg-red-600/20 text-red-400 px-4 py-2 rounded-full border border-red-600/30 mb-6">
              <MapPin size={16} />
              <span className="text-sm font-medium">Paris 16ème</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              Le centre Auto & Moto<br />
              <span className="text-red-500">premium</span> à Paris 16
            </h1>
            
            <p className="text-lg sm:text-xl text-zinc-300 mb-8 leading-relaxed">
              Lavage, detailing, mécanique et carrosserie : <br className="hidden sm:block" />
              <strong className="text-white">tout pour votre véhicule en un seul lieu</strong>
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Link to="/reservation">
                <Button size="lg" className="w-full sm:w-auto bg-red-600 hover:bg-red-700 text-white font-bold h-14 px-8 text-lg" data-testid="hero-rdv-btn">
                  <Calendar className="mr-2" size={20} />
                  Prendre rendez-vous
                </Button>
              </Link>
              <a href="tel:0805032032">
                <Button size="lg" variant="outline" className="w-full sm:w-auto border-2 border-white/30 text-white hover:bg-white/10 font-bold h-14 px-8 text-lg" data-testid="hero-call-btn">
                  <Phone className="mr-2" size={20} />
                  Appeler maintenant
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 2. PREUVE IMMÉDIATE - Stats */}
      <section className="bg-[#0d0d0f] py-8 border-y border-zinc-800" data-testid="stats-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center p-4">
              <div className="flex items-center justify-center gap-2 mb-2">
                <Wrench className="text-red-500" size={24} />
                <span className="text-3xl font-bold text-white">20+</span>
              </div>
              <p className="text-zinc-400">Prestations disponibles</p>
            </div>
            <div className="text-center p-4">
              <div className="flex items-center justify-center gap-2 mb-2">
                <MapPin className="text-red-500" size={24} />
                <span className="text-3xl font-bold text-white">2400m²</span>
              </div>
              <p className="text-zinc-400">D'atelier équipé</p>
            </div>
            <div className="text-center p-4">
              <div className="flex items-center justify-center gap-2 mb-2">
                <Users className="text-red-500" size={24} />
                <span className="text-3xl font-bold text-white">20+</span>
              </div>
              <p className="text-zinc-400">Techniciens qualifiés</p>
            </div>
            <div className="text-center p-4">
              <div className="flex items-center justify-center gap-2 mb-2">
                <Wallet className="text-red-500" size={24} />
                <span className="text-3xl font-bold text-white">0€</span>
              </div>
              <p className="text-zinc-400">Devis gratuit</p>
            </div>
          </div>
        </div>
      </section>

      {/* LOI HAMON - LIBRE CHOIX DU RÉPARATEUR */}
      <section className="py-8 bg-gradient-to-r from-blue-900/30 via-blue-600/20 to-blue-900/30 border-y border-blue-500/30" data-testid="loi-hamon-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center">
                <Shield className="text-white" size={32} />
              </div>
            </div>
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold text-white mb-2">
                LOI HAMON • <span className="text-blue-400">LIBRE CHOIX DU RÉPARATEUR</span>
              </h3>
              <p className="text-zinc-300">
                Vous avez le <strong className="text-white">libre choix de votre réparateur automobile</strong>. 
                Votre assurance ne peut pas vous imposer un garage.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. NOS SERVICES - Par Domaine */}
      <section className="py-20 bg-[#09090B]" data-testid="services-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">NOS SERVICES</h2>
            <p className="text-zinc-400 text-lg">Une gamme complète pour votre véhicule</p>
          </div>
          
          {/* LAVAGE & DETAILING */}
          <div className="mb-16">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-14 h-14 bg-blue-500/20 rounded-xl flex items-center justify-center">
                <Droplets className="text-blue-400" size={28} />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">Lavage & Detailing</h3>
                <p className="text-zinc-400">Nettoyage premium intérieur / extérieur</p>
              </div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
              {[
                { name: "Lavage Extérieur", price: "25€", desc: "Carrosserie, jantes, vitres" },
                { name: "Lavage Intérieur", price: "35€", desc: "Aspirateur, plastiques, tissus" },
                { name: "Lavage Complet", price: "55€", desc: "Intérieur + Extérieur" },
                { name: "Detailing Formule 2", price: "600€", desc: "Lustrage inclus + finition premium" },
                { name: "Rénovation de sièges", price: "100€", desc: "Nettoyage complet & raviveur tissus/cuir" },
                { name: "Traitement Céramique", price: "Sur devis", desc: "Protection longue durée" },
                { name: "Polissage", price: "À partir de 45€", desc: "Suppression micro-rayures (selon taille et état)" },
                { name: "Lavage Moto", price: "25€", desc: "Nettoyage complet 2 roues" },
              ].map((service, idx) => (
                <Card key={idx} className="bg-zinc-900/50 border-zinc-800 hover:border-blue-500/50 transition-colors">
                  <CardContent className="p-4">
                    <h4 className="text-white font-medium mb-1">{service.name}</h4>
                    <p className="text-zinc-500 text-sm mb-2">{service.desc}</p>
                    <p className="text-blue-400 font-bold">{service.price}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
            <div className="mt-6 flex gap-4">
              <Link to="/tarifs-lavage">
                <Button className="bg-blue-600 hover:bg-blue-700 text-white">
                  Voir tous les tarifs lavage
                  <ChevronRight className="ml-2" size={18} />
                </Button>
              </Link>
              <Link to="/reservation">
                <Button variant="outline" className="border-blue-500/50 text-blue-400 hover:bg-blue-500/10">
                  Réserver
                </Button>
              </Link>
            </div>
          </div>

          {/* MÉCANIQUE */}
          <div className="mb-16">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-14 h-14 bg-red-500/20 rounded-xl flex items-center justify-center">
                <Wrench className="text-red-500" size={28} />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">Mécanique</h3>
                <p className="text-zinc-400">Entretien et réparation auto & moto</p>
              </div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
              {[
                { name: "Vidange", price: "Sur devis", desc: "Huile + filtre" },
                { name: "Révision Complète", price: "Sur devis", desc: "Vidange + filtres + contrôles" },
                { name: "Freins", price: "Sur devis", desc: "Plaquettes, disques, liquide" },
                { name: "Embrayage", price: "Sur devis", desc: "Kit complet ou partiel" },
                { name: "Distribution", price: "Sur devis", desc: "Courroie ou chaîne" },
                { name: "Diagnostic", price: "45€", desc: "Lecture codes défauts" },
                { name: "Climatisation", price: "75€", desc: "Recharge + contrôle" },
                { name: "Pneus", price: "25€/pneu", desc: "Montage, équilibrage" },
              ].map((service, idx) => (
                <Card key={idx} className="bg-zinc-900/50 border-zinc-800 hover:border-red-500/50 transition-colors">
                  <CardContent className="p-4">
                    <h4 className="text-white font-medium mb-1">{service.name}</h4>
                    <p className="text-zinc-500 text-sm mb-2">{service.desc}</p>
                    <p className="text-red-500 font-bold">{service.price}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
            <div className="mt-6 flex gap-4">
              <Link to="/services">
                <Button className="bg-red-600 hover:bg-red-700 text-white">
                  Voir tous les services méca
                  <ChevronRight className="ml-2" size={18} />
                </Button>
              </Link>
              <Link to="/devis">
                <Button variant="outline" className="border-red-500/50 text-red-400 hover:bg-red-500/10">
                  Demander un devis
                </Button>
              </Link>
            </div>
          </div>

          {/* CARROSSERIE & COVERING */}
          <div className="mb-16">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-14 h-14 bg-orange-500/20 rounded-xl flex items-center justify-center">
                <Paintbrush className="text-orange-400" size={28} />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">Carrosserie & Covering</h3>
                <p className="text-zinc-400">Réparation, peinture et personnalisation</p>
              </div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
              {[
                { name: "Débosselage", price: "Sur devis", desc: "Sans peinture (PDR)" },
                { name: "Peinture", price: "Sur devis", desc: "Retouche ou élément complet" },
                { name: "Covering", price: "Sur devis", desc: "Film vinyle personnalisé" },
                { name: "Protection PPF", price: "Sur devis", desc: "Film transparent anti-rayures" },
                { name: "Réparation Pare-chocs", price: "Sur devis", desc: "Plastique ou fibre" },
                { name: "Lustrage", price: "120€", desc: "Rénovation peinture ternie" },
                { name: "Vitres Teintées", price: "250€", desc: "Film solaire homologué" },
                { name: "Phares", price: "100€", desc: "Rénovation optiques (les deux)" },
              ].map((service, idx) => (
                <Card key={idx} className="bg-zinc-900/50 border-zinc-800 hover:border-orange-500/50 transition-colors">
                  <CardContent className="p-4">
                    <h4 className="text-white font-medium mb-1">{service.name}</h4>
                    <p className="text-zinc-500 text-sm mb-2">{service.desc}</p>
                    <p className="text-orange-400 font-bold">{service.price}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
            <div className="mt-6 flex gap-4">
              <Link to="/services">
                <Button className="bg-orange-600 hover:bg-orange-700 text-white">
                  Voir tous les services carrosserie
                  <ChevronRight className="ml-2" size={18} />
                </Button>
              </Link>
              <Link to="/devis">
                <Button variant="outline" className="border-orange-500/50 text-orange-400 hover:bg-orange-500/10">
                  Demander un devis
                </Button>
              </Link>
            </div>
          </div>

          {/* RÉPARATION & RÉNOVATION JANTES */}
          <div className="mb-16">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-14 h-14 bg-cyan-500/20 rounded-xl flex items-center justify-center">
                <Disc className="text-cyan-400" size={28} />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">Rénovation Jantes</h3>
                <p className="text-zinc-400">Tarifs TTC par jeu de 4 jantes alu - Décapage, peinture et finition pro</p>
              </div>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              {/* Jantes 1 couleur */}
              <Card className="bg-zinc-900/50 border-zinc-800 hover:border-cyan-500/50 transition-colors">
                <CardContent className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="text-white text-lg font-bold">Jantes Alu - 1 couleur</h4>
                    <span className="bg-cyan-500/20 text-cyan-400 px-3 py-1 rounded-full text-xs font-semibold">FINITION UNIE</span>
                  </div>
                  <p className="text-zinc-500 text-sm mb-4">Prix pour les 4 jantes - TTC</p>
                  <div className="space-y-3">
                    <div className="flex justify-between items-center pb-3 border-b border-zinc-800">
                      <div>
                        <p className="text-zinc-300 font-medium">14 à 16 pouces</p>
                        <p className="text-zinc-500 text-xs">Citadines, compactes</p>
                      </div>
                      <p className="text-cyan-400 font-bold text-lg">À partir de 130€</p>
                    </div>
                    <div className="flex justify-between items-center pb-3 border-b border-zinc-800">
                      <div>
                        <p className="text-zinc-300 font-medium">17 à 19 pouces</p>
                        <p className="text-zinc-500 text-xs">Berlines, SUV</p>
                      </div>
                      <p className="text-cyan-400 font-bold text-lg">À partir de 150€</p>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="text-zinc-300 font-medium">Au-dessus de 20 pouces</p>
                        <p className="text-zinc-500 text-xs">SUV premium, 4x4</p>
                      </div>
                      <p className="text-cyan-400 font-bold text-lg">À partir de 180€</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Jantes Bi-ton */}
              <Card className="bg-zinc-900/50 border-zinc-800 hover:border-purple-500/50 transition-colors">
                <CardContent className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="text-white text-lg font-bold">Jantes Bi-ton ou Polychromées</h4>
                    <span className="bg-purple-500/20 text-purple-400 px-3 py-1 rounded-full text-xs font-semibold">FINITION PREMIUM</span>
                  </div>
                  <p className="text-zinc-500 text-sm mb-4">Prix pour les 4 jantes - TTC</p>
                  <div className="space-y-3">
                    <div className="flex justify-between items-center pb-3 border-b border-zinc-800">
                      <div>
                        <p className="text-zinc-300 font-medium">14 à 16 pouces</p>
                        <p className="text-zinc-500 text-xs">Citadines, compactes</p>
                      </div>
                      <p className="text-purple-400 font-bold text-lg">À partir de 145€</p>
                    </div>
                    <div className="flex justify-between items-center pb-3 border-b border-zinc-800">
                      <div>
                        <p className="text-zinc-300 font-medium">17 à 19 pouces</p>
                        <p className="text-zinc-500 text-xs">Berlines, SUV</p>
                      </div>
                      <p className="text-purple-400 font-bold text-lg">À partir de 165€</p>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="text-zinc-300 font-medium">Au-dessus de 20 pouces</p>
                        <p className="text-zinc-500 text-xs">SUV premium, 4x4</p>
                      </div>
                      <p className="text-purple-400 font-bold text-lg">À partir de 200€</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
            <p className="text-zinc-500 text-xs mt-4 italic">
              * Prix indicatifs pour la rénovation complète d'un jeu de 4 jantes. Le tarif final dépend de l'état initial des jantes et du diamètre exact. Tarif sur place ou intervention possible.
            </p>
            <div className="mt-6 flex gap-4">
              <Link to="/devis">
                <Button className="bg-cyan-600 hover:bg-cyan-700 text-white" data-testid="quote-jantes-btn">
                  Demander un devis jantes
                  <ChevronRight className="ml-2" size={18} />
                </Button>
              </Link>
            </div>
          </div>

          {/* AUTRES SERVICES */}
          <div>
            <div className="flex items-center gap-4 mb-8">
              <div className="w-14 h-14 bg-purple-500/20 rounded-xl flex items-center justify-center">
                <Sparkles className="text-purple-400" size={28} />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">Autres Services</h3>
                <p className="text-zinc-400">Contrôle technique, dépannage et plus</p>
              </div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
              {[
                { name: "Contrôle Technique", price: "Sur devis", desc: "Agréé tous véhicules" },
                { name: "Dépannage 24h/24", price: "Sur devis", desc: "Intervention rapide Paris/IDF" },
                { name: "Remorquage", price: "Sur devis", desc: "Transport véhicule" },
                { name: "Carte Grise", price: "Sur devis", desc: "Démarches administratives" },
                { name: "Véhicule de Courtoisie", price: "Gratuit*", desc: "*Sous conditions" },
                { name: "Gardiennage", price: "35€", desc: "Parking sécurisé" },
                { name: "Convoyage", price: "Sur devis", desc: "Livraison véhicule" },
                { name: "Expertise", price: "Sur devis", desc: "Avant achat / sinistre" },
              ].map((service, idx) => (
                <Card key={idx} className="bg-zinc-900/50 border-zinc-800 hover:border-purple-500/50 transition-colors">
                  <CardContent className="p-4">
                    <h4 className="text-white font-medium mb-1">{service.name}</h4>
                    <p className="text-zinc-500 text-sm mb-2">{service.desc}</p>
                    <p className="text-purple-400 font-bold">{service.price}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
            <div className="mt-6 flex gap-4">
              <Link to="/services">
                <Button className="bg-purple-600 hover:bg-purple-700 text-white">
                  Voir tous les services
                  <ChevronRight className="ml-2" size={18} />
                </Button>
              </Link>
              <Link to="/depannage">
                <Button variant="outline" className="border-purple-500/50 text-purple-400 hover:bg-purple-500/10">
                  Dépannage urgent
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 4. POURQUOI NOUS CHOISIR */}
      <section className="py-20 bg-gradient-to-b from-[#0d0d0f] to-[#09090B]" data-testid="why-us-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Pourquoi choisir <span className="text-red-500">Le Hub Atelier</span> ?
            </h2>
            <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
              Chez nous, votre véhicule est entre de bonnes mains
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: Sparkles, title: "Tout en un seul lieu", desc: "Lavage, mécanique, carrosserie : plus besoin de courir partout" },
              { icon: Clock, title: "Gain de temps", desc: "Service rapide et efficace, véhicule de courtoisie disponible" },
              { icon: Award, title: "Résultat premium", desc: "Travail soigné avec des produits et équipements professionnels" },
              { icon: Users, title: "Service client réactif", desc: "Équipe à l'écoute, devis gratuit et transparent" },
              { icon: MapPin, title: "Au cœur de Paris", desc: "Situé au 142 Bd Murat, facilement accessible" },
              { icon: Shield, title: "Agréé Assurances", desc: "Prise en charge directe avec votre assurance" },
            ].map((item, idx) => (
              <div key={idx} className="flex items-start gap-4 p-6 bg-zinc-900/30 rounded-xl border border-zinc-800 hover:border-red-500/30 transition-colors">
                <div className="w-12 h-12 bg-red-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <item.icon className="text-red-500" size={24} />
                </div>
                <div>
                  <h3 className="text-white font-bold mb-1">{item.title}</h3>
                  <p className="text-zinc-400 text-sm">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 5. AVANT / APRÈS */}
      <section className="py-20 bg-[#09090B]" data-testid="before-after-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Des résultats qui <span className="text-red-500">parlent d'eux-mêmes</span>
            </h2>
            <p className="text-zinc-400 text-lg">Découvrez nos transformations</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="relative group overflow-hidden rounded-2xl">
              <img src={BEFORE_AFTER_1} alt="Avant/Après détail" className="w-full h-80 object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
              <div className="absolute bottom-6 left-6">
                <span className="bg-green-500 text-white px-4 py-2 rounded-full text-sm font-bold">Detailing Formule 2</span>
                <p className="text-white mt-2 font-medium">Carrosserie brillante comme neuve</p>
              </div>
            </div>
            <div className="relative group overflow-hidden rounded-2xl">
              <img src={BEFORE_AFTER_2} alt="Après lavage" className="w-full h-80 object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
              <div className="absolute bottom-6 left-6">
                <span className="bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-bold">Lavage Complet</span>
                <p className="text-white mt-2 font-medium">Finition impeccable</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 6. AVIS CLIENTS */}
      <section className="py-20 bg-gradient-to-b from-[#09090B] to-[#0d0d0f]" data-testid="reviews-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="text-yellow-500 fill-yellow-500" size={28} />
              ))}
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Ce que disent nos clients</h2>
            <p className="text-zinc-400 text-lg">Plus de 500 clients satisfaits</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {reviews.map((review, idx) => (
              <Card key={idx} className="bg-zinc-900/50 border-zinc-800 hover:border-yellow-500/30 transition-colors">
                <CardContent className="p-6">
                  <div className="flex items-center gap-1 mb-4">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} className="text-yellow-500 fill-yellow-500" size={16} />
                    ))}
                  </div>
                  <Quote className="text-zinc-700 mb-2" size={24} />
                  <p className="text-zinc-300 text-sm mb-4 line-clamp-4">{review.text}</p>
                  <div className="border-t border-zinc-800 pt-4">
                    <p className="text-white font-medium">{review.name}</p>
                    <p className="text-zinc-500 text-xs">{review.date}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* 7. COMMENT ÇA MARCHE */}
      <section className="py-20 bg-[#0d0d0f]" data-testid="how-it-works-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Comment ça marche ?</h2>
            <p className="text-zinc-400 text-lg">Simple, rapide et efficace</p>
          </div>
          
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { step: "1", title: "Prenez rendez-vous", desc: "En ligne ou par téléphone, choisissez votre créneau", icon: Calendar },
              { step: "2", title: "Déposez votre véhicule", desc: "Accueil personnalisé et diagnostic gratuit", icon: Car },
              { step: "3", title: "On s'occupe de tout", desc: "Notre équipe réalise les travaux", icon: Wrench },
              { step: "4", title: "Récupérez comme neuf", desc: "Votre véhicule prêt, résultat garanti", icon: CheckCircle },
            ].map((item, idx) => (
              <div key={idx} className="text-center relative">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4 relative z-10">
                  <span className="text-white text-2xl font-bold">{item.step}</span>
                </div>
                {idx < 3 && (
                  <div className="hidden md:block absolute top-8 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-red-600 to-red-600/20" />
                )}
                <item.icon className="text-red-500 mx-auto mb-3" size={32} />
                <h3 className="text-white font-bold mb-2">{item.title}</h3>
                <p className="text-zinc-400 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 8. LOCALISATION */}
      <section className="py-20 bg-[#09090B]" data-testid="location-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
                Votre centre auto à <span className="text-red-500">Paris 16</span>
              </h2>
              <p className="text-zinc-300 text-lg mb-6">
                Situé au <strong className="text-white">142 Boulevard Murat</strong>, Le Hub Atelier vous accueille pour tous vos besoins automobiles à Paris.
              </p>
              <div className="space-y-4 mb-8">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-red-600/20 rounded-full flex items-center justify-center">
                    <MapPin className="text-red-500" size={20} />
                  </div>
                  <div>
                    <p className="text-white font-medium">142 Boulevard Murat</p>
                    <p className="text-zinc-400">75016 Paris</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-red-600/20 rounded-full flex items-center justify-center">
                    <Phone className="text-red-500" size={20} />
                  </div>
                  <div>
                    <p className="text-white font-medium">0805 032 032</p>
                    <p className="text-zinc-400">Appel gratuit</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-red-600/20 rounded-full flex items-center justify-center">
                    <Clock className="text-red-500" size={20} />
                  </div>
                  <div>
                    <p className="text-white font-medium">Lun-Sam: 8h00-19h30</p>
                    <p className="text-zinc-400">Dépannage 24h/24</p>
                  </div>
                </div>
              </div>
              <a href="https://maps.google.com/?q=142+Boulevard+Murat+75016+Paris" target="_blank" rel="noopener noreferrer">
                <Button className="bg-red-600 hover:bg-red-700 text-white">
                  <MapPin className="mr-2" size={18} />
                  Voir sur Google Maps
                </Button>
              </a>
            </div>
            <div className="rounded-2xl overflow-hidden border border-zinc-800 h-[400px]">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2626.2!2d2.2598!3d48.8396!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e67a9e6d4c1c1d%3A0x0!2s142%20Boulevard%20Murat%2C%2075016%20Paris!5e0!3m2!1sfr!2sfr!4v1234567890"
                width="100%" 
                height="100%" 
                style={{ border: 0 }}
                allowFullScreen 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Localisation Le Hub Atelier"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Dépannage Banner */}
      <section className="bg-gradient-to-r from-orange-900/30 via-orange-600/20 to-orange-900/30 py-6 border-y border-orange-500/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 bg-orange-600 rounded-full flex items-center justify-center animate-pulse">
                <Truck className="text-white" size={28} />
              </div>
              <div>
                <h3 className="text-white font-bold text-xl">DÉPANNAGE & REMORQUAGE 24h/24</h3>
                <p className="text-zinc-300">Intervention rapide sur Paris et Île-de-France</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-3">
              <a href="tel:0805032032">
                <Button className="bg-orange-600 hover:bg-orange-700 text-white font-bold text-lg h-12 px-6">
                  <Phone size={20} className="mr-2" />
                  0805 032 032
                </Button>
              </a>
              <Link to="/depannage">
                <Button variant="outline" className="border-orange-500/50 text-white hover:bg-orange-500/10 h-12">
                  En savoir plus
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 9. CTA FINAL */}
      <section className="py-24 bg-gradient-to-b from-[#0d0d0f] via-red-950/20 to-[#09090B] relative" data-testid="final-cta-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Prêt à redonner une <span className="text-red-500">nouvelle vie</span> à votre véhicule ?
          </h2>
          <p className="text-zinc-300 text-lg mb-10 max-w-2xl mx-auto">
            Contactez-nous dès maintenant pour un devis gratuit ou prenez rendez-vous en ligne
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/reservation">
              <Button size="lg" className="w-full sm:w-auto bg-red-600 hover:bg-red-700 text-white font-bold h-16 px-10 text-lg" data-testid="final-cta-rdv-btn">
                <Calendar className="mr-2" size={24} />
                Prendre rendez-vous
              </Button>
            </Link>
            <a href="tel:0805032032">
              <Button size="lg" variant="outline" className="w-full sm:w-auto border-2 border-white/30 text-white hover:bg-white/10 font-bold h-16 px-10 text-lg" data-testid="final-cta-call-btn">
                <Phone className="mr-2" size={24} />
                Appeler maintenant
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
